<template>
    <AdminPageInner :breadcrumbs="breadcrumbs">
        <template #heading v-if="assignment.id">{{ assignment.title }}</template>
        <AssignmentForm
            :assignment="assignment"
            :assignmentLabel="assignmentLabel"
            @submit="onSubmit">
            
            <template #footer>
                <div class="flex flex-row-reverse items-center">
                    <SubmitButton
                        :submitting="form.processing"
                        :disabled="form.errors.any()">
                        {{ assignment.id ? 'Update' : 'Create' }}
                    </SubmitButton>
                    <router-link :to="redirectRoute" class="text-gray-500 mr-4">
                        Cancel
                    </router-link>
                </div>
            </template>

        </AssignmentForm>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import AssignmentForm from "@/Pages/Admin/Assignment/Components/Form";
import SubmitButton from "@/Components/Form/SubmitButton";
import SessionDatesForm from "@/Pages/Admin/Courses/Components/SessionDatesForm";

export default {

    name: "AssignmentEditPage",

    data() {
        return {
            assignment: {},
            form: this.$form(),
            formComponent: 'AssignmentForm',
            course: {},
            assignment: {}
        }
    },

    provide() {
        return {
            form: this.form,
        }
    },

    components: {
        AdminPageInner,
        AssignmentForm,
        SessionDatesForm,
        SubmitButton
    },

    methods: {
        setData(data) {
            this.course = data.course;
            this.form.withData({
                course_id: data.assignment.course_id,
                title: data.assignment.title,
                description: data.assignment.description,
                status: data.assignment.status ? data.assignment.status : 1,
                new_status: {
                    upload: null,
                    description: null
                },
                statuses: data.assignment.statuses,
                type: data.assignment.type,
                validate_only: false
            });
            this.assignment = data.assignment;
        },
        onSubmit() {

            
            if (this.form.processing) {
                return;
            }

            if ( this.assignment.id ) {
                this.form.put(route('api.assignments.update', this.assignment))
                    .then(async course => {
                            this.$notify.success('Assignment updated');
                            await this.$router.push(this.redirectRoute);
                    })
                    .catch(() => {})
                    .then(() => {});
            } else {
                this.form.post(route('api.assignments.store', this.assignment))
                    .then(async course => {
                            this.$notify.success('Assignment created');
                            await this.$router.push(this.redirectRoute);
                    })
                    .catch(() => {})
                    .then(() => {});
            }
        }
    },

    computed: {
        
        assignmentLabel() {
            return ( !this.$route.meta.isCertificate ) ? 'Assignment' : 'Certificate';
        },
        assignmentsRoute() {
            return ( !this.$route.meta.isCertificate ) ? 'admin.assignments.index' : 'admin.certificates.index';
        },
        breadcrumbs() {
            return [
                {
                    label: 'Admin', to: {name: 'admin'}
                },
                {
                    label: 'Courses', to: {name: 'admin.courses.index'}
                },
                {
                    label: `${this.course.title || 'Course'}`,
                    to: {name: 'admin.courses.show', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: this.assignmentLabel, 
                    to: this.redirectRoute
                },
                {
                    label: `${this.assignment.title || 'Course'}`,
                    to: {name: this.$route.name, params: this.$route.params}
                },
            ];
        },

        redirectRoute() {
            return ( !this.$route.meta.isCertificate ) ? {name: 'admin.assignments.index', params: {courseId: this.$route.params.courseId}} : {name: 'admin.certificates.index', params: {courseId: this.$route.params.courseId}};
        }
    },

    watch: {
        formComponent() {
            document.querySelector('#app > div').scrollTo(0, 0);
        }
    },

    async beforeRouteEnter(to, from, next) {
        const data = await fetchData(to);
        next(vm => vm.setData(data));
    },

    async beforeRouteUpdate(to, from) {
        const data = await fetchData(to);
        this.setData(data);
    },
};
const fetchData = async (to) => {

    const data = await Promise.all([
        axios.get(route('api.courses.show', to.params.courseId), {params: to.query}),
        axios.get(route('api.assignments.edit', to.params.assignmentId), {params: to.query})
    ])

    return {
        course: data[0].data,
        assignment: data[1].data
    };
}
</script>
